import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';

@Component({
  selector: 'app-industry-report-suggestion',
  templateUrl: './industry-report-suggestion.component.html',
  styleUrls: ['./industry-report-suggestion.component.scss']
})
export class IndustryReportSuggestionComponent implements OnInit {
  public isSearching = true;
  industryList: any;
  fundingList: any;

  filterIndustry = {
    category: [{ value: 'IND_REPORT', matchMode: 'in', operator: 'or' }],
  };
  filterFunding = {
    category: [{ value: 'FND_REPORT', matchMode: 'in', operator: 'or' }],
    subcategory: [{ value: 'WEEKLY_REPORT', matchMode: 'in', operator: 'or' }],
  };
  filterMonthlyFunding = {
    category: [{ value: 'FND_REPORT', matchMode: 'in', operator: 'or' }],
    subcategory: [{ value: 'MONTHLY_REPORT', matchMode: 'in', operator: 'or' }],
  };

  paginationRequest = {
    field: 'published_date',
    order: -1,
    rows: 1,
    page: 0,
    totalRecords: 0,
  };
  fundingMontlyList: any;

  constructor(private companyService: CompanyService,
    private router : Router
  ) {}

  ngOnInit(): void {
    this.getIndustryReport();
    this.getFundingReport();
    this.getFundingMontlyReport();
  }

  getIndustryReport() {
    this.isSearching = true;
    let query = {
      field: this.paginationRequest.field,
      order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.filterIndustry,
    };

    this.companyService
      .getIndustryReport(query)
      .then((data:any) => {
        this.industryList = data.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  demandReportRequest(){
    this.router.navigate(['/customised/report']);
  }

  getFundingReport() {
    this.isSearching = true;
    let query = {
      field: this.paginationRequest.field,
      order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.filterFunding,
    };

    this.companyService
      .getIndustryReport(query)
      .then((data : any) => {
        this.fundingList = data.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  getFundingMontlyReport() {
    this.isSearching = true;
    let query = {
      field: this.paginationRequest.field,
      order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.filterMonthlyFunding,
    };

    this.companyService
      .getIndustryReport(query)
      .then((data : any) => {
        this.fundingMontlyList = data.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
}
